// ============================================================================
// NETWORK CONFIGURATION
// ----------------------------------------------------------------------------
// Switch between networks by changing NETWORK_MODE below.
// This is CODE-SIDE ONLY — never exposed to UI.
//
//   'production' = opBNB Mainnet  (chainId 204)
//   'staging'    = opBNB Testnet  (chainId 5611)
// ============================================================================

export const NETWORK_MODE = 'production'; // change to 'production' for mainnet

const NETWORKS = {
  production: {
    chainId: 204,
    chainIdHex: '0xCC',
    name: 'opBNB',
    rpcUrls: [
      'https://opbnb-mainnet-rpc.bnbchain.org',
      'https://opbnb-rpc.publicnode.com',
      'https://1rpc.io/opbnb'
    ],
    blockExplorer: 'https://opbnbscan.com',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18
    },
    // Block where CoreStorage was deployed (lookup floor for event scans).
    // Set this to the actual deployment block to speed up admin queries.
    // Leave 0 to scan all history (slower).
    deployBlock: 139538576,
    // Max blocks per getLogs / queryFilter call. opBNB public RPC limits ~5000.
    logChunkSize: 4900,
    // Server-side eligibility cache (PHP endpoint on Hostinger). Set to your
    // deployed URL to share scan state across devices. Null = localStorage only.
    cacheApiUrl: 'https://galaxyxon.com/api/eligibility-cache.php'
  },
  staging: {
    chainId: 5611,
    chainIdHex: '0x15EB',
    name: 'opBNB',
    rpcUrls: [
      'https://opbnb-testnet-rpc.bnbchain.org',
      'https://opbnb-testnet.publicnode.com'
    ],
    blockExplorer: 'https://opbnb-testnet.bscscan.com',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18
    },
    deployBlock: 0,
    logChunkSize: 4900,
    cacheApiUrl: null
  }
};

export const ACTIVE_NETWORK = NETWORKS[NETWORK_MODE];

export const getAddEthereumChainParams = () => ({
  chainId: ACTIVE_NETWORK.chainIdHex,
  chainName: ACTIVE_NETWORK.name,
  nativeCurrency: ACTIVE_NETWORK.nativeCurrency,
  rpcUrls: ACTIVE_NETWORK.rpcUrls,
  blockExplorerUrls: [ACTIVE_NETWORK.blockExplorer]
});
